<template>
  <div v-if="!show" class="ui active loader"></div>
  <div v-if="show" id="contain" class="ui aligned padding">
    <form class="ui large form" @submit.prevent="generatePackage">
      <div class="ui field" style="padding: 10px 0px 20px 0px!important">
        <i class="ui arrow left icon" v-on:click="goBack()" style="float: left;font-size: 25px;"></i>
        <i class="ui window close outline icon" v-on:click="sessionClose()" style="float: right;font-size: 25px;"></i>
      </div>

      <div id="idFistItems" class="ui field">
        <label>Pedido Cliente</label>
        <div class="ui field">
          <div class="ui left icon input">
            <i class="ui mobile alternate icon"></i>
            <input type="number" id="idphone" name="phone" v-model="parcelInfo.phone" maxlength="9" placeholder="Número Móvil" autofocus required oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" min="0">
          </div>
        </div>

        <div class="ui field">
          <div class="ui left icon input">
            <i class="ui shopping basket icon"></i>
            <input type="text" id="idname" name="name" v-model="parcelInfo.name" placeholder="Referencia Pedido">
          </div>
        </div>

        <div class="ui field" v-if="payment">
          <div class="ui left icon input">
            <i class="ui euro sign icon"></i>
            <input type="number" id="idimporte" name="importe" step="any" v-model="parcelInfo.importe" maxlength="9" placeholder="Importe">
          </div>     
          
          <div class="ui left icon input" style="height:35px; padding-top:10px;" v-if="payment">
            <label style="color:grey!important; display:flex; align-items:center">
              <input type="checkbox" id="idpaid" name="paid" v-model="parcelInfo.paid" style="margin-right:15px; width:15px; height:15px;" v-on:click="checkShopPayment(parcelInfo.paid)">
              <!-- Gestión de pago en tienda. -->
              Pago en tienda.
            </label>
          </div>
        </div>

        <div class="ui field" id="idBtnConfirm">
          <a  v-on:click="showNextItems()">
            <i class="ui big share icon" style="border:shadow: red"></i>
          </a>
        </div>
      </div>

      <div id="idSiguiente" class="ui field">
        <div class="ui field" id="idSecondItems">
          <label>Para Recoger en:</label>
            <a v-if="locker" id="locker" class="classEnviroment" v-on:click="selectEnviroment('locker')" ><i class="ui big th icon"><h3 id="h3_locker">Locker</h3></i></a>
            <a v-if="cart" id="cart" class="classEnviroment" v-on:click="selectEnviroment('cart')"><i class="ui big dolly flatbed icon"><h3 id="h3_cart">Carrito</h3></i></a>
            <a v-if="cold" id="cold" class="classEnviroment" v-on:click="selectEnviroment('cold')"><i class="ui big snowflake icon"><h3 id="h3_cold">Frio</h3></i></a>
            <a v-if="slot99" id="slot99" class="classEnviroment" v-on:click="selectEnviroment('slot99')"><i class="ui big warehouse icon"><h3 id="h3_slot99">Almacén</h3></i></a>
        </div>

        <div id="idThirdItems" class="ui field" v-if="viewSlotSize">
          <label>Selecciona Tamaño</label>
          <div v-if="(parcelSizes.length==0) && !error" class="ui active centered inline loader small"></div>
          <div v-if="(parcelSizes.length>0) && !error" class="ui stackable divided container">
            <sizeModule :theSizes="parcelSizes" :defaultSelected="defaultSelected" @on-size-selected="sizeSelected($event)" ></sizeModule>
          </div>
        </div>

        <div class="ui field">
          <!-- <button id="idBtnGenerar" class="ui fluid large teal button hapiick" type="submit">Generar Envío<br> Abrir Puerta</button> -->
          <button id="idBtnGenerar" class="ui fluid large teal button hapiick" type="submit">Abrir Puerta</button>
        </div>
      </div>
    </form>
  </div>

</template>
<script>
import sizeModule from '@/components/sizeModule.vue'
export default {
  name: 'GenerateParcel',
  data() {
    return {
      apm: null,
      token: null,
      hs: null,
      msg: null,
      type: null,
      title: null,
      closeSession: 1,
      codError: null,
      show: false,
      viewSlotSize: false,
      parcelInfo: {
        place_id: null,
        name: null,
        phone: null,
        importe: null,
        paid: null,
        slot_size: null,
        size_id: null,
        multiOrderCode: null,
        multiOrderCount: 1,
      },
      payment: null,
      providerError: null,
      parcelSizes: [],
      shipment: null,
      change_size: false,
      error_operin: false,
      enviroments: [],
      enviromentSelected: false,
      sameOrder: false,
      locker: 0,
      cart: 0,
      cold: 0,
      slot99: 0,
    }
  },
  created() {
    this.token = localStorage.token;
    this.apm = localStorage.apm;
    this.hs = localStorage.virtualService_id;

    if (!this.token) {
      this.redirect(401,this.title,'','',this.token,this.closeSession);
    } else {
      this.initializeEnviroment();
      this.getEmptySlots(this.apm);
    }
  },
  methods: {
    checkShopPayment() {
      let checkpaidvalue = document.getElementById('idpaid').checked
      if (checkpaidvalue) {
        //mostrar pop up para que confirme que quiere realziar la gestion en tienda
        this.$swal({
          text: 'El pago se gestionará en tienda.',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result) => {
          if (!result.isConfirmed) {
            document.getElementById('idpaid').checked = false;
            this.parcelInfo.paid = false;
          }
        })
      }
    },
    goBack() {
      this.$router.push({name: 'MenuService'});
    },
    sessionClose(){
      this.codError = '';
      this.msg = 'Carga de pedidos terminada.';
      this.type = 'success';
      this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
    },
    getEmptySlots(apm) {
      let url = this.$url_hapiick + "/v1/apms/data?apm="+apm;
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.get(url,{
        headers: headers
      })
      .then((request)  => {
        this.codError = request.data.error;
        if (this.codError) {
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
            this.locker = 1;

            if (request.data.type.slot99) {
              this.slot99 = request.data.type.slot99;
            }
            if (request.data.type.cold) {
              this.cold = request.data.type.cold;
            }
            if (request.data.type.cart) {
              this.cart = request.data.type.cart;
            }

            this.payment = request.data.payment;

            this.loadApmCapacity(request.data.empty_slots)
          }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    loadApmCapacity(slots) {
      if (!slots) {
        this.codError = '';
        this.msg = 'No se ha podido conectar con la máquina para obtener los huecos libres. Vuelve a intentarlo pasados unos minutos.';
        this.type = 'info';
        this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
      }

      this.parcelSizes = slots.map((slot) => {
        //let sizes = ['XS', 'S', 'M', 'L', 'XL'];
        let sizes = ['XS', 'S', 'S+', 'M', 'M+','MD','L','L+','LD','XL','XL+','DXL','XXL','XXL+','C']

        let sort = sizes.indexOf(slot.title);
        return {
          id: slot.title,
          dim: sizes[slot.title],
          empty: slot.empty,
          sizeId: slot.sizeId,
          sort: sort
        }
      })
      .sort((a, b) => {
        return a.sort - b.sort
      });

      this.show = true;
      this.defaultSelected = this.getDefaultSelected();
    },
    checkEmptySlots() {
      let totalHuecosLibres = 0;
      for (var i = 0; i < this.parcelSizes.length; i++) {
        totalHuecosLibres = totalHuecosLibres + this.parcelSizes[i].empty
      }

      if (totalHuecosLibres > 0) {
        this.locker = 1;
      } else {
        this.locker = 0;
        this.viewSlotSize = false;
      }
    },
    getDefaultSelected() {
      let default_selected = this.parcelSizes.find((a) => a.empty > 0);
      return default_selected
    },
    showNextItems(){
      let firstDigit = 0;
      let phoneLength = 0;

      if (this.parcelInfo.phone === null) {        
        this.$swal({
          icon: 'info',
          text: 'Número de teléfono obligatorio. Este campo no puede estar vacío.',
        })
      } else {
        this.selectEnviroment('locker'); //Poner para que por defecto este seleccionado el icono del locker y este visible los tamaños y el tamaño mas pequeños seleccionado.

        firstDigit = this.parcelInfo.phone.substr(0,1);
        phoneLength = this.parcelInfo.phone.length

        if ((firstDigit == 6 || firstDigit == 7) && phoneLength == 9 && !isNaN(this.parcelInfo.phone)) {
          if(this.payment) {
            if(this.parcelInfo.paid === null && this.parcelInfo.importe === null) {
              this.$swal({
                icon: 'info',
                text: 'Tienes que indicar el importe del pedido.',
              })
            } else if((this.parcelInfo.paid === null || this.parcelInfo.paid === false) && this.parcelInfo.importe == 0) {
              this.$swal({
                icon: 'info',
                text: 'El importe no puede ser 0. Si no quieres pago automático, marca la opción pago en tienda.',
              })
            } else {
              document.getElementById('idSiguiente').style.visibility = "visible"
              document.getElementById('idBtnConfirm').style.display = "none"
            }
          } else {
            document.getElementById('idSiguiente').style.visibility = "visible"
            document.getElementById('idBtnConfirm').style.display = "none"
          }
        } else {
          this.$swal({
            icon: 'info',
            text: 'Número de teléfono no valido. Por favor, vuelve a intentarlo.',
          })
        }
      }
    },
    generatePackage(){
      document.getElementById('idBtnGenerar').disabled = true;

      let firstDigit = 0;
      let phoneLength = 0;

      if (this.parcelInfo.phone === null) {        
        this.$swal({
          icon: 'info',
          text: 'Número de teléfono obligatorio. Este campo no puede estar vacío.',
        })
      } else {
        firstDigit = this.parcelInfo.phone.substr(0,1);
        phoneLength = this.parcelInfo.phone.length

       if(this.enviromentSelected === false) {
          this.$swal({
            icon: 'info',
            text: 'Debes seleccionar un entorno.',
          })
          document.getElementById('idBtnGenerar').disabled = false;
          return;
        }

        if(this.viewSlotSize && this.parcelInfo.size_id === null) {
          this.$swal({
            icon: 'info',
            text: 'Debes seleccionar un tamaño.',
          })
          document.getElementById('idBtnGenerar').disabled = false;
          return;
        }

        if ((firstDigit == 6 || firstDigit == 7) && phoneLength == 9 && !isNaN(this.parcelInfo.phone)) {
          //Comprobar si tiene pago
          if(this.payment) {
            if((this.parcelInfo.paid === null || this.parcelInfo.paid === false) && this.parcelInfo.importe === null) {
              this.$swal({
                icon: 'info',
                text: 'Tienes que indicar el importe del pedido.',
              })
              document.getElementById('idBtnGenerar').disabled = false;
              return;
            } else if((this.parcelInfo.paid === null || this.parcelInfo.paid === false) && this.parcelInfo.importe == 0) {
              this.$swal({
                icon: 'info',
                text: 'El importe no puede ser 0. Si no quieres pago automático, marca la opción pago en tienda.',
              })
              document.getElementById('idBtnGenerar').disabled = false;
              return;
            }
          }

          if (this.shipment === null || (this.sameOrder && this.error_operin === false && this.change_size === false)) {
            let url = this.$url_hapiick + '/v1/shipments/generate-and-operin';
            let headers = {
              'Content-Type': 'application/json',
              'X-Auth-Token': this.token,
            }
            if (this.$subscription !== '') {
              headers['Ocp-Apim-Subscription-Key'] = this.$subscription
            }

            this.axios.post(url, {
              apm: this.apm,
              phone: this.parcelInfo.phone,
              name: this.parcelInfo.name,
              amount: this.parcelInfo.importe,
              paid: this.parcelInfo.paid,
              size_id: this.parcelInfo.size_id,
              slot_size: this.parcelInfo.slot_id,
              multiorder_code: this.parcelInfo.multiOrderCode,
              multiorder_count: this.parcelInfo.multiOrderCount,
            },{
              headers: headers
            })
            .then((request)  => {
              this.generateResult(request);
            })
            .catch((error) => {
              this.catchErrors(error);
            })
          } else { //cambio de tamaño
            let url = this.$url_hapiick + '/v1/shipments/change-size';
            let headers = {
              'Content-Type': 'application/json',
              'X-Auth-Token': this.token,
            }
            if (this.$subscription !== '') {
              headers['Ocp-Apim-Subscription-Key'] = this.$subscription
            }

            this.axios.post(url, {
              apm: this.apm,
              barcode: this.shipment.barcode,
              size_id: this.parcelInfo.size_id,
              slot_size: this.parcelInfo.slot_id,
            },{
              headers: headers
            })
            .then((request)  => {
              this.generateResult(request);
            })
            .catch((error) => {
              this.catchErrors(error);
            })
          }

/*           if(this.payment) {
            if((this.parcelInfo.paid === null || this.parcelInfo.paid === false) && this.parcelInfo.importe === null) {
              this.$swal({
                icon: 'info',
                text: 'Tienes que indicar el importe del pedido.',
              })
              document.getElementById('idBtnGenerar').disabled = false;
            } else {
              if (this.shipment === null || (this.sameOrder && this.error_operin === false && this.change_size === false)) {
                let url = this.$url_hapiick + '/v1/shipments/generate-and-operin';
                let headers = {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': this.token,
                }
                if (this.$subscription !== '') {
                  headers['Ocp-Apim-Subscription-Key'] = this.$subscription
                }

                this.axios.post(url, {
                  apm: this.apm,
                  phone: this.parcelInfo.phone,
                  name: this.parcelInfo.name,
                  amount: this.parcelInfo.importe,
                  paid: this.parcelInfo.paid,
                  size_id: this.parcelInfo.size_id,
                  slot_size: this.parcelInfo.slot_id,
                  multiorder_code: this.parcelInfo.multiOrderCode,
                  multiorder_count: this.parcelInfo.multiOrderCount,
                },{
                  headers: headers
                })
                .then((request)  => {
                  this.generateResult(request);
                })
                .catch((error) => {
                  this.catchErrors(error);
                })
              } else { //cambio de tamaño
                let url = this.$url_hapiick + '/v1/shipments/change-size';
                let headers = {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': this.token,
                }
                if (this.$subscription !== '') {
                  headers['Ocp-Apim-Subscription-Key'] = this.$subscription
                }

                this.axios.post(url, {
                  apm: this.apm,
                  barcode: this.shipment.barcode,
                  size_id: this.parcelInfo.size_id,
                  slot_size: this.parcelInfo.slot_id,
                },{
                  headers: headers
                })
                .then((request)  => {
                  this.generateResult(request);
                })
                .catch((error) => {
                  this.catchErrors(error);
                })
              }
            }
          } else {
            document.getElementById('idSiguiente').style.visibility = "visible"
            document.getElementById('idBtnConfirm').style.display = "none"
          } */
        } else {
          this.$swal({
            icon: 'info',
            text: 'Número de teléfono no valido. Por favor, vuelve a intentarlo.',
          })
          document.getElementById('idBtnGenerar').disabled = false;
        }
      }
    },
    generateResult(request) {
      this.codError = request.data.error
      this.shipment = request.data

      document.getElementById('idBtnGenerar').disabled = false;
      if (this.codError) {
        if (request.data.provider_error) {
          this.providerError = request.data.provider_error.message
        }
        if (request.data.shipment) {
          this.shipment = request.data.shipment
        }
        this.backError(this.codError,this.providerError);
      } else {
        this.parcelInfo.multiOrderCode = this.shipment.multiorder_code

        this.$swal({
          text: '¿Has introducido correctamente el paquete?',
          icon: 'info',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No, cancelar operación',
          denyButtonText: 'No, cambiar tamaño',
          allowOutsideClick: false, //Evitar que el pop up se cierre al pulsar fuera de el
        }).then((result) => {
          if (result.isConfirmed) {
            
            this.parcelSizes = this.parcelSizes.map((a) => {
              if (a.id == this.parcelInfo.slot_size) {
                a.empty -= 1
              }
              return a
            })

            this.$swal({
              text: '¿Has terminado con el pedido actual?',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si',
              cancelButtonText: 'No, necesito otro cajon',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.modelOtherOrder();
              } else {
                this.parcelInfo.slot_size = null;
                this.parcelInfo.size_id = null;
                this.sameOrder = true;
                this.parcelInfo.multiOrderCount = this.parcelInfo.multiOrderCount + 1;
                this.change_size = false;

                if (this.parcelInfo.multiOrderCode) {
                  document.getElementById("idphone").readOnly = true
                  document.getElementById("idname").readOnly = true
                  document.getElementById("idimporte").readOnly = true
                  document.getElementById("idpaid").disabled = true
                }
 
                this.selectEnviroment('locker');
                this.viewSlotSize = true;
              }
            })
          } else if (result.isDenied) { //CAMBIO TAMAÑO
            this.change_size = true;
            this.changeSize(this.shipment);
          } else { //CANCELAR OPERACION
            this.cancelShipment(this.shipment);
          }
        })
      }
    },
    modelOtherOrder(){
      this.$swal({
        text: '¿Quieres cargar otro pedido?',
        icon: 'info',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, cerrar sesion',
        denyButtonText: 'No, volver al menu',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          document.getElementById('idBtnGenerar').disabled = false;
          this.parcelInfo.place_id = null;
          this.parcelInfo.name = null;
          this.parcelInfo.phone = null;
          this.parcelInfo.importe = null;
          this.parcelInfo.paid = null;
          this.parcelInfo.slot_size = null;
          this.parcelInfo.size_id = null;
          this.parcelInfo.multiOrderCode = null;
          this.parcelInfo.multiOrderCount = 1;
          this.shipment = null;
          this.viewSlotSize = false;
          this.change_size = false;
          this.error_operin = false;
          this.sameOrder = false;

          document.getElementById("idphone").value = ''
          document.getElementById("idname").value = ''
          document.getElementById("idimporte").value = ''
          document.getElementById("idpaid").checked = false

          document.getElementById("idphone").readOnly = false
          document.getElementById("idname").readOnly = false
          document.getElementById("idimporte").readOnly = false
          document.getElementById("idpaid").disabled = false

          this.initializeEnviroment();

          document.getElementById('idSiguiente').style.visibility = "hidden"
          document.getElementById('idBtnConfirm').style.display = "block"
        } else if (result.isDenied) {
          this.$router.push({name: 'MenuService'});
        } else {
          this.codError = '';
          this.msg = 'Carga de pedidos terminada.';
          this.type = 'success';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        }
      })
    },
    changeSize(shipment) {

      let url = this.$url_hapiick + '/v1/shipments/operin/cancel';
      let headers = {
          'Content-Type': 'application/json',
          'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        parcel_id: shipment.parcel_id,
      },{
        headers: headers
      })
      .then((request)  => {
        this.codError = request.data.error
        if (this.codError) {
          if (request.data.provider_error) {
            this.providerError = request.data.provider_error.message
          }

          this.backError(this.codError,this.providerError);
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    cancelShipment(shipment) {
      let url = this.$url_hapiick + '/v1/shipments/operin/cancel';
      let headers = {
          'Content-Type': 'application/json',
          'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        parcel_id: shipment.parcel_id,
      },{
        headers: headers
      })
      .then((request)  => {
        this.shipment = null;

        this.codError = request.data.error
        if (this.codError) {
          if (request.data.provider_error) {
            this.providerError = request.data.provider_error.message
          }

          this.backError(this.codError,this.providerError);
        } else {
          this.$swal({
            text: '¿Quieres realizar otra operación?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Si, volver al menu',
            cancelButtonText: 'No, cerrar sesion',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({name: 'MenuService'});
            } else {
              this.codError = '';
              this.msg = 'Carga de pedidos terminada.';
              this.type = 'success';
              this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
            }
          })
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    operoutShipment(shipment){

      let url = this.$url_hapiick + '/v1/shipments/operout';
      let headers = {
          'Content-Type': 'application/json',
          'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        parcel_id: shipment.parcel_id,
      },{
        headers: headers
      })
      .then((request)  => {
        this.codError = request.data.error
        if (this.codError) {
          if (request.data.provider_error) {
            this.providerError = request.data.provider_error.message
          }

          this.backError(this.codError,this.providerError);
        } else {
          this.modelOtherOrder();
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    sizeSelected(event) {
      this.parcelInfo.slot_size = event.id
      this.parcelInfo.size_id = event.sizeId
    },
    initializeEnviroment(){
      var elements = document.getElementsByClassName('classEnviroment'), i, len;
      for (i = 0, len = elements.length; i < len; i++) {
        elements[i].style.color = 'lightgrey';
      }

      var h3elements = document.getElementsByTagName('h3');
      for (i = 0, len = h3elements.length; i < len; i++) {
        h3elements[i].style.visibility = 'hidden';
      }
    },
    selectEnviroment(enviroment){
      this.initializeEnviroment();
      this.enviromentSelected = true;
      document.getElementById(enviroment).style.color = "#00f9a9"
      document.getElementById("h3_"+enviroment).style.visibility = "visible"

      if (enviroment === 'locker') {
        this.viewSlotSize = true
      } else {
        this.viewSlotSize = false;
      }
    },
    backError(codError,providerError){
      if (codError == 500) {
        if (providerError === 'opened_slot') {
          this.$swal({
            icon: 'info',
            text: 'Para poder introducir el siguiente envió, por favor, asegurate de haber cerrado el cajon.',
          })
          this.error_operin = true;
          document.getElementById('idBtnGenerar').disabled = false;
        } else if (providerError === 'no_response_from_apm') {
          this.$swal({
            icon: 'error',
            title: 'ERROR INTERNO.',
            text: 'Por favor, vuelve a intentarlo. Si persiste el problema, ponte en contacto con nosotros a traves del teléfono 934 177 199. Disculpa las molestias. Gracias.',
          })
          this.error_operin = true;
          document.getElementById('idBtnGenerar').disabled = false;
        } else if (this.providerError === 'system_exception') { //En este caso no haremos nada
          //console.log('providerError: '+providerError)
        } else if (providerError === 'no_locker_size_provided') {
          this.$swal({
            icon: 'info',
            text: 'Por favor, selecciona el tamaño del slot.',
          })
          this.error_operin = true;
          document.getElementById('idBtnGenerar').disabled = false;
        } else {
          codError = '';
          this.type = 'error';
          this.title = 'OPERACIÓN CANCELADA.';
          this.msg = 'Ponte en contacto a través del teléfono 934 177 199. Disculpa las molestias. Gracias.';
          this.redirect(codError,this.title,this.msg, this.type,this.token,this.closeSession);
        }
      } else {
        this.redirect(codError,this.title,'','',this.token,this.closeSession);
      }
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {  
      this.$router.push({name: 'Messages',params: {codError: codError, title: title, msg: msg, type:type, token:token, closeSession:closeSession}});
    }
  },
  components: {
    sizeModule,
  }
}
</script>

<style scoped>
h3{
  font-size: 13px!important;
  color:lightgrey;
  visibility: hidden;
}
a {
  color: darkslategrey;
}

form {
  width: 100%;
}

label {
  text-align: left;
  color:black!important;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] { 
  -moz-appearance:textfield;
}

input:focus,
input:hover{
  border-color: #00f9a9 !important;
}

input:-webkit-autofill {
  box-shadow: unset!important;
  border-color: #00f9a9!important;
}


input, button {
  height: calc(2.7em + 1vw);
  font-size: 1em!important;
}

a>.share {
  margin: 10px!important
}

i.th, i.warehouse,i.dolly,i.thermometer, i.snowflake{
  margin: 5px 17px 5px 17px!important;
  font-size: 35px!important;
}

i.mobile, i.shopping, i.euro {
  font-size: 30px;
}

#contain {
  margin: auto!important;
  width: 95%;
  height: 85%;
  position: absolute;
  top: 10%;
  left: 2.5%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

#menu {
  margin-bottom: 5px;
  margin-left: 15px;
}

#menu2 {
  visibility: hidden;
}

#idBtnGenerar, #idBtnConfirm {
  margin-top: 20px!important;
  line-height: inherit;
}

#idFistItems, #idSecondItems, #idThirdItems {
  border: 1px solid lightgrey;
  border-radius: .28571429rem;
}

#idFistItems, #idThirdItems {
  padding: 5px 10px 0px 10px;
}


#idSecondItems {
  padding: 5px 10px 15px 10px;
}

#idSiguiente {
  visibility: hidden;
}

.share {
  color: black;
  box-shadow: 0px 0px 10px #00f9a9!important;
}

.ui.header {
  margin-bottom: 0.9em!important;
  text-align: left;
  font-size: calc(1em + 1vw);
}

.ui[class*="left icon"].input>i.icon {
  height: 100%;
  width: 45px;
}

.ui[class*="left icon"].input>input {
  padding-left: 45px!important;
}

.ui.input>input {
  text-align: center;
}

.ui.button {
  padding: 0px!important;
}

.row {
  width: 100%;
}

.content {
  height: 100%;
  width: 100%;
  font-size: 18px!important;
} 

.field {
  width: 100%;
  margin: 0 0 0.5em!important;
}

.fields {
  text-align: left;
  float: left;
  display: flex;
  align-items: center;
  line-height: normal;
  font-size: 16px;
  margin-bottom: 0.8em!important;
}

.fields img {
  width: 65px;
}

.classEnviroment {
  color:lightgrey;
}

.hapiick {
  color: black !important;
  background-color: #00f9a9 !important;
}

.ui.grid>.centered.column, .ui.grid>.row>.centered.column {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.ui.grid .ui.stackable.grid, .ui.segment:not(.vertical) .ui.stackable.page.grid {
  margin: 0!important;
  width: 100%!important;
}

@media only screen and (min-width: 1200px) {
.ui.grid.container {
  width: 100%!important;
}
}
</style>
